import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css";

import "./App.css";

//Componentes
import ScrollToTop from "./components/components/scrolltotop";
import ErrorMensaje from "./components/components/errormensaje";
import Home from "./components/pages/home";
import MHome from "./components/pages/mhome";
import Contacto from "./components/pages/contacto";
import Info from "./components/pages/info";
import FromPresentacion from "./components/pages/formpresentacion";
import Propuesta from "./components/pages/propuesta";
import Login from "./components/pages/login";
import Consola from "./components/pages/consola";
import AdminPropuesta from "./components/pages/adminpropuesta";
import ImprimirPropuesta from "./components/pages/imprimirpropuesta";
import FormVotacionPrivada from "./components/pages/fromvotacionprivada";
import Fiscalizar from "./components/pages/fiscalizar";
import FormVotacion from "./components/pages/formvotacion";

//Contextos
import MunicipiosContext from "./context/MunicipiosContext";
import AuthContext from "./context/AuthContext";

//configuracion de axios
axios.defaults.withCredentials = true;

function App() {
  const [municipios, guardarMunicipios] = useState([]);
  const [loggedIn, guardarLoggedIn] = useState(undefined);

  //Se obtienen todos los municipios participantes.
  useEffect(() => {
    const obtenerMunicipios = () => {
      axios
        .get("/api/municipios")
        .then((res) => {
          guardarMunicipios(res.data.municipios);
        })
        .catch((error) => {
          console.log(error);
          //TO DO: Hacer algo con el error!!
        });
    };
    obtenerMunicipios();
  }, []);

  //Se obtiene si hay un usuario logeado. El array vacío hace que se ejecute
  //una sola vez al montar la app: sin él, el useEffect corría en cada render
  //(cada respuesta llamaba a guardarLoggedIn, que re-renderizaba y volvía a
  //disparar el GET), generando pedidos infinitos a /api/usuarios/loggedIn.
  //El estado se mantiene al día porque el login y el logout llaman a
  //guardarLoggedIn directamente.
  useEffect(() => {
    async function obtenerLoggedIn() {
      const loggedInRes = await axios.get("/api/usuarios/loggedIn");
      guardarLoggedIn(loggedInRes.data);
    }
    obtenerLoggedIn();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <MunicipiosContext.Provider value={{ municipios }}>
        <AuthContext.Provider value={{ loggedIn, guardarLoggedIn }}>
          <Switch>
            {/*Página de redirecionamiento a las distintas instancias.*/}
            <Route exact path="/" component={() => <Home />} />
            {/*Página principal del municipio*/}
            <Route
              exact
              path="/municipio/:munUrl"
              component={() => <MHome />}
            />
            {/*Página de contacto del municipio*/}
            <Route
              exact
              path="/municipio/:munUrl/contacto"
              component={() => <Contacto />}
            />
            {/*Página de información sobre la implementación del presupuesto participativo*/}
            <Route
              exact
              path="/municipio/:munUrl/info"
              component={() => <Info />}
            />
            {/*Página del formulario de presentación de propuesta*/}
            <Route
              exact
              path="/municipio/:munUrl/presentacion"
              component={() => <FromPresentacion />}
            />

            {/*Página del formulario de presentación de propuesta*/}
            <Route
              exact
              path="/municipio/:munUrl/votacion/:propuestaId"
              component={() => <FormVotacion />}
            />
            {/*Página para ver una propuesta en particular*/}
            <Route
              exact
              path="/municipio/:munUrl/propuesta/:propuestaId"
              component={() => <Propuesta />}
            />

            {/*Página de Login*/}
            <Route exact path="/login" component={() => <Login />} />

            {/*Página para ver una propuesta en particular*/}
            <Route exact path="/consola" component={() => <Consola />} />

            {/*Edición de una Propuesta */}
            <Route
              exact
              path="/consola/propuesta/:id"
              component={() => <AdminPropuesta />}
            />
            {/*Vista de impresión de una Propuesta */}
            <Route
              exact
              path="/consola/imprimir/:id"
              component={() => <ImprimirPropuesta />}
            />

            <Route
              exact
              path="/consola/formvotacion"
              component={() => <FormVotacionPrivada />}
            />

            <Route
              exact
              path="/consola/fiscalizar"
              component={() => <Fiscalizar />}
            />

            {/*Error 404: en vez de redirigir en silencio al inicio, se muestra
               un mensaje claro con salida al inicio.*/}
            <Route
              render={() => (
                <ErrorMensaje
                  titulo="Página no encontrada"
                  mensaje="El enlace puede estar mal escrito o la página ya no existe."
                />
              )}
            />
          </Switch>
        </AuthContext.Provider>
      </MunicipiosContext.Provider>
    </Router>
  );
}

export default App;
